/**
 * 超出label宽度的部分会被显示成...，比如“这是一条很长很长的字符串”可能会显示为“这是一条很长...”
 */

const {ccclass, property} = cc._decorator;

@ccclass
export default class FixedLengthLabel extends cc.Component {
    start () {
        let label = this.getComponent(cc.Label)
        if (label && label.overflow !== cc.Label.Overflow.NONE) {
            let maxCharNum = Math.floor(this.node.width / label.fontSize)
            let charNum = label.string.length
            charNum > maxCharNum && (label.string = label.string.substr(0, maxCharNum - 1) + "...")
        }
    }
}
